/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2019-08-26 09:11:29
 * @LastEditTime: 2021-06-09 15:44:57
 * @LastEditors: dezhi
 */
import axios from "@/assets/js/http";
const state = {
    studentInfo: {}
}

// getters
const getters = {

}

// actions
const actions = {
    /**
     * @description: 新增考生信息
     * @param {commit} 
     * @return: 
     */
    async getStudentInfo({
        commit
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/queryCwaInfo?examCode=${payload.examCode}&userCode=${payload.userCode}`)
        localStorage.setItem('studentInfo', JSON.stringify(res.data.data))
        console("", commit);
        return res;
    },
    /**
     * @description: 获取图片
     * @param {*} commit
     * @param {*} payload
     * @return {*}
     */
    async getPicUrl({
        commit
    }, payload) {
        const res = await axios.post('/v1.0.0/exammgr/upload/uploadFile', payload).then((response) => {
            return Promise.resolve(response)
        }).catch((e) => {
            console.log(e)
            return Promise.reject(new Error('fail'))
        })
        console("", commit);
        return res
    },
    /**
     * @description: 新增考生信息
     * @param {commit} 
     * @return: 
     */
    async addStudentAction({
        commit
    }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/saveCWAInfo`, payload)
        console("", commit);
        return res;
    },
    /**
     * @description: 修改考生信息
     * @param {commit} 
     * @return: 
     */
    async updateStudentAction({
        dispatch
    }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/updateByUpdateParam`, payload)
        let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
        dispatch('getStudentInfo', {
            orderCode: userInfo.orderCode,
            userCode: userInfo.userCode
        })
        return res;
    },
    /**
     * @description: 上传承诺书
     * @param {commit} 
     * @return: 
     */
    async updateBookAction({
        dispatch
    }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/updateDeclareUrlById/${JSON.parse(localStorage.getItem("studentInfo")).enrollInfoId}`, payload)
        let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
        dispatch('getStudentInfo', {
            orderCode: userInfo.orderCode,
            userCode: userInfo.userCode
        })
        return res;
    },
    /**
     * @description: 获取考点地址
     * @param {commit} 
     * @return: 
     */
    async getExamPlace({
        dispatch
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/examArea/queryList`, {
            params: {
                examCode: payload.examCode,
                deleteFlag: 0,
                status: 1
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 获取手机验证码
     * @param {commit} 
     * @return: 
     */
    async getPhoneCode({
        dispatch
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/check`, {
            params: {
                phone: payload
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 验证手机号
     * @param {commit} 
     * @return: 
     */
    async validPhoneCode({
        dispatch
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/verifyPhoneAndCode`, {
            params: {
                phone: payload.phone,
                code: payload.code
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 获取考生信息
     * @param {commit} 
     * @return: 
     */
    async getExamInfo({
        dispatch
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/admissionTicket/queryAdmissionTicketBy?enrollInfoId=${payload.enrollInfoId}&examCode=${payload.examCode}`, {
            // params: {
            //     enrollInfoId: payload
            // }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 获取考生信息
     * @param {commit} 
     * @return: 
     */
    async getDownloadTime({
        dispatch
    }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/admissionTicket/updateScoreInfo`, {
            params: {
                enrollInfoId: payload
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 下载证书
     * @param {commit} 状态提交触发函数
     * @param {dispatch} 异步请求提交触发函数
     * @param {} 
     * @param {}  
     * @return: 
     */
    async downloadBookAct({
        dispatch
    }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/certificate/queryCertificateAndSave`, payload)
        console.log(dispatch)
        return res
    },










}


// mutations

const mutations = {
    saveStudentInfo(state, payload) {
        // state.classInfo = state.infoList[payload - 1];
        state.studentInfo = payload;
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}